import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Product, Scope, ScopeQuestion, StandardName} from "../../../../../store/state/order.state";
import {ChangeSet} from "../../../history/order-history.model";
import {ClientCountryBasedConfig} from "../../../../../configuration/configuration.model";

@Component({
    selector: 'scopes-details',
    templateUrl: './scopes-details.template.html',
    styleUrls: ['./scopes-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ScopesDetailsComponent {

	@Input() product: Product;
	@Input() scopes: Scope[];
	@Input() standard: StandardName;
	@Input() changeSet: ChangeSet;	// optional
	@Input() translateClientsData;
	@Input() useOriginalTranslations: boolean;
	@Input() config: ClientCountryBasedConfig;

	notEmpty(questions: ScopeQuestion[]): boolean {
		return questions && questions.length > 0;
	}

	randomNumber(): number {
		return Math.random();
	}

	isScopeAddedOrRemoved(): boolean {
		if (this.changeSet == null || this.changeSet.changes.productChanges[this.standard] == null || this.changeSet.changes.productChanges[this.standard].scopes == null) {
			return false;
		}

		const scopeChanges = this.changeSet.changes.productChanges[this.standard].scopes;
		return Object.keys(scopeChanges).some(scopeCode => ["ADDED", "REMOVED"].includes(scopeChanges[scopeCode].changeType));
	}

	isScopeQuestionChanged(scopeCode: string, questionType: string): boolean {
		let scopeChanged = !!this.changeSet && !!this.changeSet.changes.productChanges[this.standard] &&
			!!this.changeSet.changes.productChanges[this.standard].scopes &&
			!!this.changeSet.changes.productChanges[this.standard].scopes[scopeCode];

		if (!scopeChanged) {
			return false;
		}

		let changeType = this.changeSet.changes.productChanges[this.standard].scopes[scopeCode].changeType;
		return changeType == 'ADDED' ||
			changeType == 'QUESTION_CHANGED' &&
			!!this.changeSet.changes.productChanges[this.standard].scopes[scopeCode].questionChanges.find(qc => qc.questionType == questionType);
	}

	get is9001Product(): boolean {
		return this.product.standard.name === StandardName.ISO_9001;
	}

	isCatastrophicRiskChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].catastrophicRisk;
	}

	isNumberOfEmployeesWithinScopeChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].employeesWithinScope;
	}

	showCatastrophicRisk() {
		if (!this.config) return true;
		return this.config.order.showIso9001CatastrophicRisk
	}

	get is27x01Product() {
		return [StandardName.ISO_27001, StandardName.ISO_27001].includes(this.standard);
	}
}
